import { NewsInterface } from '../../interfaces/news.interface';
import * as newsEn from './en/news.en';
import * as newsRu from './ru/news.ru';

export default {
  en: newsEn.default,
  ru: newsRu.default,
} as Record<string, NewsInterface[]>;
